/* compose save functions across components */
import axios from 'axios';
import { mapState, mapGetters } from 'vuex';
import { designSavePayload, getCircularReplacer } from '@/utils';

export default {
  // created() {
  //   this.hello();
  // },
  computed: {
    ...mapState(['config', 'products', 'designs']),
    ...mapGetters(['skuMap']),
  },
  methods: {
    // hello() {
    //   console.log('hello from mixin!');
    // },
    saveDesign(makeCopy = false) {
      console.log(this.config.designSaveURL);
      console.log('saving these designs:', this.designs);
      const params = [];
      Object.entries(this.designs).forEach(([key, design]) => {
        if (design.image.key) {
          params.push(designSavePayload(design, this.products[key], false, makeCopy));
        }
      });
      console.log('sending params:', params);
      console.log(params);
      axios.post(this.config.designSaveURL, params)
        .then((response) => {
          response.data.forEach((datum) => {
            const { id, name, product } = datum;
            const k = this.skuMap[product];
            console.log('save... designcode:', id, 'name:', name, 'product', product, 'k', k);

            this.designs[k].designcode = id;
            this.designs[k].name = name;
          });
          this.$store.commit('clearSavedDesigns', response.data);
          this.$store.commit('updateLastSavedDesigns');

          if (!this.config.user) {
            console.log('no user; prompt login');
            this.$bvToast.toast(
              'To come back to your saved designs, log in or create an account. Click here or visit the menu in the upper left corner.',
              {
                title: 'Design Saved - Not logged in',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 25000,
                variant: 'primary',
                solid: true,
                href: this.config.loginURL,
              },
            );
          } else {
            this.$bvToast.toast(
              'We saved your design. Woo!',
              {
                title: 'Design Saved',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                solid: true,
              },
            );
          }
        })
        .catch((error) => {
          console.log(error);
          let errmsg = 'An unknown error occurred.';
          if (error.request) {
            console.log(error.request);
            errmsg = `An error occurred: ${error.response.statusText} (${error.response.status})`;
          } else if (error.response) {
            console.log(error.response);
            errmsg = 'Could not contact the server.';
          } else {
            console.log(error.message);
            errmsg = `An unexpected error occurred. Please contact info@bottlemark.com: ${error.message}.`;

            // try to report a (safed) version of what happened to the server
            const errParams = JSON.stringify(params, getCircularReplacer());
            axios.post(
              this.config.logURL,
              {
                location: 'DesignSave.vue',
                message: error.message,
                params: errParams,
                error: error.toJSON(),
              },
            ); // no .then/.error as we don't care what happens
          }
          this.$bvToast.toast(
            errmsg,
            {
              title: 'Save Error',
              toaster: 'b-toaster-top-center',
              autoHideDelay: 12000,
              variant: 'danger',
              solid: true,
            },
          );
        });
    },
  },
};
